import { configureStore } from '@reduxjs/toolkit';
import homeScreenReducer from './slices/HomeScreen';
import globalReducer from './slices/Global';
import departamentosPageReducer from './slices/DepartamentosPage';
import revisionRecursosPageReducer from './slices/RevisionRecursosPage';
import auditoriaPageReducer from './slices/AuditoriaPage';
import misRecursosPageReducer from './slices/MisRecursosPage';
import misMateriasPageReducer from './slices/MisMateriasPage';

export const store = configureStore({
  reducer: {
    homeScreen: homeScreenReducer,
    global: globalReducer,
    departamentosPage: departamentosPageReducer,
    revisionRecursosPage: revisionRecursosPageReducer,
    auditoriaPage: auditoriaPageReducer,
    misRecursosPage: misRecursosPageReducer,
    misMateriasPage: misMateriasPageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
